
import '../utils/axiosConfig'; // runs the 401/403 logout logic globally
import React, { useState, useEffect } from 'react';
import "../Style/CookieConsent.css";

// Simple cookie storage helper
const cookieStorage = {
  getItem: (item) => {
    const cookies = document.cookie
      .split(';')
      .map(cookie => cookie.split('='))
      .reduce((acc, [key, value]) => ({ ...acc, [key.trim()]: value }), {});
    return cookies[item];
  },
  // Set a cookie with an expiration in days (default is 30 days)
  setItem: (item, value, days = 30) => {
    const now = new Date();
    now.setTime(now.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = now.toUTCString();
    document.cookie = `${item}=${value}; expires=${expires}; path=/`;
  }
};

const storageType = cookieStorage;
const consentPropertyName = 'jdc_consent';
const shouldShowPopup = () => !storageType.getItem(consentPropertyName);
const saveToStorage = () => storageType.setItem(consentPropertyName, 'accepted', 30);

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // On page load, check for consent.
    // If not present, show the banner after a 2-second delay.
    if (shouldShowPopup()) {
      setTimeout(() => {
        setVisible(true);
      }, 2000);
    }
  }, []);

  const handleAccept = () => {
    saveToStorage();
    setVisible(false);
    console.log('User accepted cookies (expires in 30 days).');
  };

  const handleReject = () => {
    // Optionally, you can set a "rejected" cookie here if needed.
    document.cookie = `${consentPropertyName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    setVisible(false);
    console.log('User rejected cookies; consent cookie removed.');
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-bar">
      <p>
        This website uses cookies to provide a personalized browsing experience and necessary site functionality. 
        By continuing to use our site, you agree to our use of cookies and collection of personal data.
        Do you agree to the use of cookies as outlined in: 
        <a href="https://kpmg.com/ke/en/home/misc/privacy.html" target="_blank" rel="noopener noreferrer"> Kenya</a> | 
        <a href="https://kpmg.com/gh/en/home/misc/privacy.html" target="_blank" rel="noopener noreferrer"> Ghana</a> | 
        <a href="https://kpmg.com/ng/en/home/misc/privacy.html" target="_blank" rel="noopener noreferrer"> Nigeria</a> | 
        <a href="https://assets.kpmg.com/content/dam/kpmg/za/pdf/2024/South%20Africa%20Privacy%20Statement.pdf" target="_blank" rel="noopener noreferrer"> South Africa</a> | 
        <a href="https://assets.kpmg.com/content/dam/kpmg/za/pdf/2024/Zambia%20Privacy%20Statement.pdf" target="_blank" rel="noopener noreferrer"> Zambia</a> | 
        <a href="https://assets.kpmg.com/content/dam/kpmg/za/pdf/2024/Zimbabwe%20Privacy%20Statement.pdf" target="_blank" rel="noopener noreferrer"> Zimbabwe</a> | 
        <a href="https://assets.kpmg.com/content/dam/kpmg/za/pdf/2024/Mauritius%20Privacy%20Statement.pdf" target="_blank" rel="noopener noreferrer"> Mauritius</a> | 
        <a href="https://assets.kpmg.com/content/dam/kpmg/za/pdf/2024/Mozambique%20Privacy%20Statement%20-%20July%202024.pdf" target="_blank" rel="noopener noreferrer"> Mozambique</a> | 
        <a href="https://kpmg.com/ke/en/home/misc/privacy.html" target="_blank" rel="noopener noreferrer"> Rwanda</a> | 
        <a href="https://kpmg.com/ke/en/home/misc/privacy.html" target="_blank" rel="noopener noreferrer"> Tanzania</a> | 
        <a href="https://kpmg.com/ke/en/home/misc/privacy.html" target="_blank" rel="noopener noreferrer"> Uganda</a>
      </p>
      <div className="cookie-buttons">
        <button className="cookie-btn accept" onClick={handleAccept}>
          Accept
        </button>
        <button className="cookie-btn reject" onClick={handleReject}>
          Reject
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
